import React from 'react';
import { Container, Card, ListGroup, ListGroupItem, Row, Col, Button } from 'react-bootstrap';

const About = () => {
    return (
        <div>
            <Container>
                <h1>About</h1>
                <p> Company Overview: </p>
                <p>Eye of China Import Export-Registration Number: 2021/358681/07 </p>

                <p>
                    Is a professional import and export development consulting and advisory company. It is aimming at helping  businessmen who are in importing and exporting business both from South Africa and China to achive their business target. It was certified by the China Embassy with two directors from both local South Africa and from China.
            </p>
                <Row className="justify-content-md-center">
                    <Col xs lg="4">
                        <Card>
                            <Card.Img variant="top" src="./../assets/images/profile1a.png" />
                            <Card.Body>
                                <Card.Title>
                                    <h3>Tim Hogins</h3>
                                    <p>Director </p>
                                </Card.Title>
                                <Card.Text>
                                 
                                 Timothy Paul Hogins is a believer and a doer. Timothy Paul Hogins is an African businessman, entrepreneur, investor and philanthropist. Tim is a Dreamer. <br /> <br />
                                 
                                 Tim is a Visualiser.  <br />
                                 
                                 
                                </Card.Text>
                            </Card.Body>

                            <Card.Body>
                                <Card.Link href="/Tim"><Button>Read More</Button></Card.Link>
                                {/* <Card.Link href="#">Another Link</Card.Link> */}
                            </Card.Body>
                        </Card>

                    </Col>
                    <Col xs lg="4">

                        <Card>
                            <Card.Img variant="top" src="./../assets/images/profile1b.png" />
                            <Card.Body>
                                <Card.Title>
                                <h3>Grace Fan</h3>
                                    <p>Director </p>
                                </Card.Title>
                                <Card.Text>
                                Specialized in doing international trading between China to South Africa from 2008 up to now.<br /> <br />

                                Products verify from Power transformers, cables, solar lights and solar relative products...</Card.Text>
                            </Card.Body>

                            <Card.Body>
                                <Card.Link href="/Grace"><Button>Read More</Button></Card.Link>
                                {/* <Card.Link href="#">Another Link</Card.Link> */}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                



            </Container>
        </div>
    );
};

export default About;